<template lang="pug">
  transition(name="fade")
    article.pt-px(v-if="doc")
      breadcrumb-nav(isLibrary="true")
      header.my-120
        container.px-15(width="md")
          //- title
          h1.font-sabon.mb-60.md-mb-120(v-if="doc.acf.title.length", v-html="hd(doc.acf.title)", :class="h1Clss")
          //- attribution
          .text-11.md-text-13(v-for="(node, i) in attribution.children", v-html="node.innerHTML", :style="{marginLeft: `calc(1.5em * ${i})`}")
      flex-body.font-sabon(:rows="doc.acf.article_body")
      further-reading(:doc="doc.acf")
</template>

<script>
import BreadcrumbNav from '@/components/BreadcrumbNav'
import Container from '@/components/Container'
import FlexBody from '@/components/FlexBody/FlexBody'
import FurtherReading from '@/components/FurtherReading'
import _get from 'lodash/get'
import { plainTitle } from '@/utils'
export default {
  name: 'Article',
  props: ['slug'],
  data () {
    return {
      doc: null
    }
  },
  computed: {
    attribution () {
      const bdy = document.createElement('div')
      bdy.innerHTML = this.doc.acf.attribution
      return bdy
    },
    h1Clss () {
      const isLg = _get(this.doc, 'acf.title_font_size') === 'lg'
      return {
        'text-21 md-text-46 leading-nrml tracking-tight': isLg,
        'text-21 md-text-24': !isLg
      }
    }
  },
  methods: {
    hd (str, tag = 'h1') {
      return str.replace(/<p/g, '<' + tag).replace(/<\/p>/g, '</' + tag + '>')
    },
    async getArticle () {
      const qry = this.$route.query
      if (qry.id && qry.preview) return this.$store.dispatch('getPreview', { type: 'posts', ...qry })
      return this.$store.dispatch('getArticle', this.slug)
    }
  },
  created () {
    this.getArticle().then(doc => { this.doc = doc })
  },
  metaInfo () {
    if (!this.doc) return
    const title = plainTitle(this.doc)
    return {
      title: title,
      meta: this.$store.getters.meta({ title: title, descrip: false })
    }
  },
  components: { BreadcrumbNav, Container, FlexBody, FurtherReading }
}
</script>

<style>
</style>
